module.exports = __webpack_public_path__ + "img/arhieraticon-1777-pagina-de-titlu-big.81483701.jpg";